import type { ReactElement, ReactNode } from "react";
import { NotificationsProvider } from "@/components/Notifications/NotificationsProvider";
import { AppHeader } from "./AppHeader";

interface Props {
  children: ReactNode;
}

export function AppShell({ children }: Readonly<Props>): ReactElement {
  return (
    <NotificationsProvider>
      <div className="min-h-screen bg-surface-0">
        <AppHeader />
        <div>{children}</div>
      </div>
    </NotificationsProvider>
  );
}
